import React from 'react';
import { labels } from './labels'; // Import labels if needed for dropdown defaults

// Added props for mobile Insurance/Radius filters and their handlers
const SearchFilter = ({
    options,
    gender,
    language,
    clinicalInterest,    
    insurance,    
    onInsuranceChange,
    onCheckboxChange,
    npi // To hide these if it's an NPI search anyway
}) => {

    // Keep checkbox builder
    function buildCheckBoxList(name: string, optionsList: any[] = [], checked: any[] = []) { // Add default values
        // Sort options alphabetically for better UX
        const sortedOptions = [...optionsList].sort((a, b) => a.name.localeCompare(b.name));

        return sortedOptions.map((o) => ( // Simplified map index usage
            <div className="form-check" key={`\${name}-\${o.value}`}>
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={`\${name}-\${o.value}`}
                    value={o.value}
                    defaultChecked={checked?.includes(o.value)}
                    onChange={onCheckboxChange} // Add onChange handler here
                />
                <label className="form-check-label" htmlFor={`\${name}-\${o.value}`}>{o.name}</label>
            </div>
        ));
    }

    // Return fieldsets AND the mobile-only filters
    return (<>
        {/* --- MOBILE ONLY Filters: Insurance & Radius --- */}
        {/* Wrap in a div hidden on medium screens and up */}
        {!npi && ( // Only show if not an NPI search
            <div className="mb-3">                                
                
                    <label className="form-label h6" htmlFor="insuranceDropdownMobile">Insurance</label>
                    <select
                        className="custom-select custom-select-sm" // Use form-select for Bootstrap 5 styling
                        id="insuranceDropdownMobile"
                        onChange={onInsuranceChange}
                        value={insurance}
                    >
                        <option value="">{labels.search.choose}...</option>
                        {options?.insurance?.map((i) => (
                            <option key={i.value} value={i.value}>{i.name}</option>
                        ))}
                    </select>                
            </div>
        )}

        {/* --- Checkbox Filters (Gender, CI, Language) --- */}
        <fieldset className="mb-3" id="filterGender">
            <legend className="h6">Gender of Provider</legend>
            {buildCheckBoxList("gender", options?.gender, gender)}
        </fieldset>

        <fieldset className="mb-3" id="filterClinicalInterest">
            <legend className="h6">Additional Clinical Interest</legend>
            {buildCheckBoxList("clinterest", options?.clinicalInterest, clinicalInterest)}
        </fieldset>

        <fieldset className="mb-3" id="filterLanguage">
            <legend className="h6">Languages Spoken</legend>
            {buildCheckBoxList("language", options?.language, language)}
        </fieldset>
    </>);
}

export default SearchFilter;